import { render, staticRenderFns } from "./wechatTemplateList.vue?vue&type=template&id=8f97f9c4"
import script from "./wechatTemplateList.vue?vue&type=script&lang=js"
export * from "./wechatTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports